import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import { useSectionId } from '@v4/components/common/SectionItem'
import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import useStyles from './Cta4.styled'

export const useCta4 = props => {
	const { metaData } = props
	const classes = useStyles(props)
	const sectionId = useSectionId()
	const items = PageBuilderSelector.useRepeatableGroupKeys({
		sectionId,
		group: 'items',
	})

	const { handleFocus: handleTitleClick } = useFieldFocus({ metaData: metaData.title })

	const { editable: titleEditable, handleChange: handleTitleChange } = useEditorMeta({
		metaData: metaData.title,
		key: 'title',
	})

	const columnsNumber = Math.min(metaData.columns?.toNumber(), _.size(items))
	const maxWidth = columnsNumber === 1 ? 'xs' : 'lg'

	return [
		{
			classes,
			maxWidth,
			columnsNumber,
			orientation: columnsNumber === 1 ? 'horizontal' : 'vertical',
			items,
			mobileAlignment: metaData.mobileAlignment?.metaValue,
			mobileButtonWidth: metaData.mobileButtonWidth?.isWide ? '100%' : 'auto',

			title: metaData.title?.metaValue,
			titleKey: metaData.title?.tierKey,
			titleConfig: metaData.title?.config,
			titleEditable,
		},
		{ handleTitleClick, handleTitleChange },
	]
}
